const words = {
  spanish: {
    /*     home: "Inicio",
    place: "Lugar",
    who: "Quienes Somos?",
    arrive: "Como Llegar",
    valley: "Valle de Cocora",
    services: "Servicios",
    restaurant: "Restaurante",
    coffee: "Casita del Sabor",
    lodging: "Hospedaje",
    camping: "Campamento",
    games: "Atracciones",
    horse: "Paseos Ecológicos a Caballo y Caminatas",
    crafts: "Artesanías de la Región",
    glamping: "Glamping Cocora Nidos del Cóndor",
    flowers: "Vivero Cocora Viva",
    packages: "Planes y Promociones",
    reviews: "Testimonios",
    bookings: "Reservas",
    contact: "Contáctenos", */
    us: "Nosotros",
    services: "Servicios",
    packages: "Planes y Reservas",
    contact: "Contáctenos",
  },
  english: {
    /*    home: "Home",
    place: "Place",
    who: "Who Are We?",
    arrive: "How to Arrive",
    valley: "Cocora Valley",
    services: "Services",
    restaurant: "Restaurant",
    coffee: "Coffee House",
    lodging: "Lodging",
    camping: "Camping",
    games: "Attractions",
    horse: "Eco-Friendly Activities",
    crafts: "Regional Crafts",
    glamping: "Glamping Cocora Nidos del Cóndor",
    flowers: "Florist Cocora Viva",
    packages: "Packages & Promotions",
    reviews: "Reviews",
    bookings: "Bookings",
    contact: "Contact us", */
    us: "Us",
    services: "Services",
    packages: "Packages and Bookings",
    contact: "Contact Us",
  },
};

export default words;
